import { If, Else } from "lib/@components/switch"
import { Redirect } from "lib/@components/redirect"

/**
 * Guards a System Admin page route by the same predicate that controls its left-nav
 * visibility, so feature-flagged / demand-gated pages are not reachable by direct URL
 * when their nav item is hidden. Falls back to the System Admin landing page.
 *
 * @param {object} props
 * @param {() => boolean} [props.predicate] - Visibility predicate; when it returns false the page redirects.
 * @param {React.ReactNode} props.children - The page content to render when allowed.
 */
export function SystemAdminPageGuard({ predicate, children }) {
    const allowed = isAllowed()

    return (
        <If value={allowed}>
            {children}
            <Else>
                <Redirect to="/system-admin/settings" />
            </Else>
        </If>
    )

    function isAllowed() {
        return typeof predicate === "function" ? predicate() : true
    }
}
